import { Link } from 'react-router-dom';
import Nav from '../components/common/Nav';
import Footer from '../components/common/Footer';
import Newsletter from '../components/home/Newsletter';
import SEO from '../components/common/SEO';
import { getAllPosts } from '../utils/blogLoader';

export default function Blog() {
  const posts = getAllPosts();

  return (
    <>
      <SEO 
        title="Blog"
        description="What I've learned building startups, navigating tech, and the principles I live by."
        url="/blog"
      />
      <Nav />
      
      <header style={{ padding: 0, margin: 0, minHeight: 'auto' }}>
        <div className="container" style={{ paddingTop: '96px', paddingBottom: 0 }}>
          <div className="section-header">
            <h1 style={{ fontSize: '32px', marginTop: 0, marginBottom: '15px', padding: '3px 2px', lineHeight: 1.3 }}>
              Blog
            </h1>
            <p style={{ color: 'var(--accent-color)', fontSize: '16px', lineHeight: 1.6, marginBottom: 0, padding: '3px 2px' }}>
              What I've learned building startups, navigating tech, and the principles I live by.
            </p>
            <hr style={{ border: 'none', borderTop: '1px solid var(--border-color)', margin: '22px 0' }} />
          </div>
        </div>
      </header>

      <section className="posts" style={{ borderTop: 'none', padding: 0 }}>
        <div className="container" style={{ paddingTop: 0 }}>
          <div className="section-header" style={{ marginBottom: '20px' }}>
            <h2 style={{ fontSize: '16px', fontWeight: 'normal', marginBottom: '8px' }}>All Posts</h2>
          </div>
          <div className="posts-list">
            {posts.map((post) => (
              <article key={post.slug} className="post-item">
                <div className="post-date">[{post.date}]</div>
                <h3 className="post-title">
                  <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                </h3>
                {post.excerpt && (
                  <div className="post-excerpt">{post.excerpt}</div>
                )}
              </article>
            ))}
          </div>
        </div>
      </section>

      <Newsletter />
      <Footer />
    </>
  );
}
